import React from 'react';
import { COMPONENT_TYPES } from '../config/componentConfig';
import ImageUpload from '../components/ImageUpload/ImageUpload';
import PromptInput from '../components/PromptInput/PromptInput';
import ColorPicker from '../components/ColorPicker/ColorPicker';
import ParameterSelector from '../components/ParameterSelector/ParameterSelector';
import SizeSelector from '../components/SizeSelector/SizeSelector';
import TagSelector from '../components/TagSelector/TagSelector';
import MapInfoCard from '../components/MapInfoCard/MapInfoCard';

const ComponentRenderer = ({ component, isGenerating, value, onChange, onValidationChange }) => {
  const commonProps = {
    id: component.id,
    title: component.title,
    description: component.description,
    required: component.required,
    value,
    onChange,
    onValidationChange,
    disabled: isGenerating,
    props: component.props || {},
    height: component.height
  };

  switch (component.type) {
    case COMPONENT_TYPES.IMAGE_UPLOAD:
      return <ImageUpload key={component.id} {...commonProps} />;
    case COMPONENT_TYPES.PROMPT_INPUT:
      return <PromptInput key={component.id} {...commonProps} />;
    case COMPONENT_TYPES.COLOR_PICKER:
      return <ColorPicker key={component.id} {...commonProps} />;
    case COMPONENT_TYPES.PARAMETER_SELECTOR:
      return <ParameterSelector key={component.id} {...commonProps} />;
    case COMPONENT_TYPES.SIZE_SELECTOR:
      return <SizeSelector key={component.id} {...commonProps} />;
    case COMPONENT_TYPES.TAG_SELECTOR:
      return <TagSelector key={component.id} {...commonProps} />;
    case COMPONENT_TYPES.PLACE_PICKER:
      return <MapInfoCard key={component.id} {...commonProps} />;
    case COMPONENT_TYPES.CUSTOM:
      if (component.Component) {
        const CustomComp = component.Component;
        return <CustomComp key={component.id} {...commonProps} />;
      }
      if (typeof component.render === 'function') {
        return component.render({ ...commonProps });
      }
      return null;
    default:
      return null;
  }
};

export default ComponentRenderer;
